// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsCircleAnchorPoints_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 1H10V5H14V1ZM8 20.0644V22.2501C5.1424 21.1341 2.86592 18.8576 1.74994 16H3.93558C4.80946 17.7585 6.24155 19.1906 8 20.0644ZM16 22.2501C20.0974 20.65 23.0001 16.664 23.0001 12 23.0001 7.33604 20.0974 3.35003 16.0001 1.74989V3.93553C18.9635 5.40824 21.0001 8.46629 21.0001 12 21.0001 15.5337 18.9635 18.5918 16 20.0645V22.2501ZM8.00008 3.93551V1.74987C5.14244 2.86585 2.86593 5.14236 1.74994 8H3.93558C4.80947 6.24151 6.24159 4.80939 8.00008 3.93551ZM10 19H14V23H10V19ZM5 10H1V14H5V10Z" class="svg-bg"/>
</svg>
`;
/**
 * IconAnnotationsCircleAnchorPoints is a generated icon component.
 */
let IconAnnotationsCircleAnchorPoints = IconAnnotationsCircleAnchorPoints_1 = class IconAnnotationsCircleAnchorPoints extends IconBaseElement {
    render() {
        return html `${IconAnnotationsCircleAnchorPoints_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsCircleAnchorPoints.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconAnnotationsCircleAnchorPoints = IconAnnotationsCircleAnchorPoints_1 = __decorate([
    customElement('zui-icon-annotations-circle-anchor-points')
], IconAnnotationsCircleAnchorPoints);
export { IconAnnotationsCircleAnchorPoints };
